import { TableCell, TableRow } from "@mui/material";
import ErrorView from "../../../../components/ErrorView";
import { ERROR_COMPONENTS } from "../../../../constants/common";

export default function NoDataRow(props) {
    return <TableRow><TableCell colSpan={props.colSpan} align="center" style={{ border: "none", height: "300px", color: "grey" }}>
        <ErrorView type={ERROR_COMPONENTS.NoDataFound.type} />
    </TableCell></TableRow>
}